import { types } from "mobx-state-tree";

import CONSTANTS from "const/constants";

import { UserCredentialBaseStore } from "./user-credential-base-store";

const { CREDENTIAL_TYPE_LABELS, PLATFORM_TYPES } = CONSTANTS;

const model = {
    s3IntegrationName: types.maybeNull(types.string),
    s3ProfileImageUrl: types.maybeNull(types.string),
    s3BucketName: types.maybeNull(types.string),
    s3BucketRegion: types.maybeNull(types.string),
    useAccelerate: types.maybeNull(types.boolean)
};

const volatile = (self) => {
    const __name__ = self.name;
    const __profileImage__ = self.profileImage;

    return {
        name: self?.s3IntegrationName ?? __name__,
        profileImage: self?.s3ProfileImageUrl ?? __profileImage__,
        typeLabel: CREDENTIAL_TYPE_LABELS.S3,
        platformType: PLATFORM_TYPES.S3
    };
};

const _UserCredentialS3Store = types
    .model(`UserCredentialS3`, model)
    .volatile(volatile);

export const UserCredentialS3Store = types
    .compose(UserCredentialBaseStore, _UserCredentialS3Store)
    .named(`UserCredentialS3Store`);
